import { CardStatusesResponse, ShellCardStatusesResponse } from '@odiupsk/up-api-client'

/* eslint-disable class-methods-use-this */
import { AxiosRequestConfig } from 'axios'
import { cloneDeep } from 'lodash-es'
import { codeListApi } from '.'
import { errorDuringFetch } from '../utils/i18n/alerts'
import { logError } from './utils'
import { maxPerPage } from '../utils/maxPerPage'
import { appStore } from '../AppStore'

export class ApiCodeListsRepository {
  static async fetchNotificationTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getNotificationTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchTransactionTypes(config?: AxiosRequestConfig) {
    const c = cloneDeep(config ?? { params: {} })

    c.params.scope_id = appStore.currentRole

    try {
      const res = await codeListApi.getTransactionTypes(c)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchMerchantTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getMerchantTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchCountries(config: AxiosRequestConfig = { params: { per_page: maxPerPage } }) {
    try {
      const res = await codeListApi.getCountries(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchDocumentCategoryTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getDocumentCategoryTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchDocumentContractTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getDocumentContractTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchDocumentTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getDocumentTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchDeliveryTypes(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.getDeliveryTypes(config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchCardStatuses(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.api.get<CardStatusesResponse>(`/card_statuses`, config)
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }

  static async fetchShellCardStatuses(config?: AxiosRequestConfig) {
    try {
      const res = await codeListApi.api.get<ShellCardStatusesResponse>(
        `/shell/card_statuses`,
        config
      )
      return res.data
    } catch (err) {
      logError(err as Error, errorDuringFetch)
      throw err
    }
  }
}
